(ns shared.core.toasts.data
  (:require [shared.core.reactive :as re]
            [clojure.string :as s]
            [shared.core.util :as util]))

(def toasts-path [:toasts])

(defn toasts-disabled? [db]
  (get-in db (conj toasts-path :disabled?)))

(re/reg-event-db
  :toasts/toggle-disabled re/middleware
  (fn [db]
    (update-in db (conj toasts-path :disabled?) not)))

(re/reg-sub
  :toasts/disabled?-
  toasts-disabled?)

(defn active-toasts [db]
  (when-not (toasts-disabled? db)
    (get-in db (conj toasts-path :active) [])))

(re/reg-sub :toasts/active- active-toasts)

(defn add-toast [db {:keys [kind msg duration action]}]
  (let [id (gensym "toast-")]
    (when duration
      (util/wait (if (> duration 1000) duration (* duration 1000)) #(re/dispatch [:toasts/remove id])))
    (if (some #(and (= (:kind %) kind) (= (:msg %) msg)) (active-toasts db))
      db
      (update-in db (conj toasts-path :active) conj {:id id :kind kind :msg msg :action action}))))

(re/reg-event-db
  :toasts/add-error re/middleware
  (fn [db [{:keys [msg errors duration action]}]]
    (let [msg (if (and (not msg) errors)
                (s/join ". " (map :message errors))
                msg)]
      (add-toast db {:kind :error :msg msg :duration duration :action action}))))

(re/reg-event-db
  :toasts/add-info re/middleware
  (fn [db [{:keys [msg duration action]}]]
    (add-toast db {:kind :info :msg msg :duration duration :action action})))

(re/reg-event-db
  :toasts/remove re/middleware
  (fn [db [id]]
    (let [active-toasts (active-toasts db)]
      (assoc-in db (conj toasts-path :active) (filterv #(not= (:id %) id) active-toasts)))))

(re/reg-event-db
  :toasts/remove-all re/middleware
  (fn [db]
    (assoc-in db (conj toasts-path :active) [])))
